import { render } from "./AttributeInfo.vue?vue&type=template&id=f023bd68&scoped=true"
import script from "./AttributeInfo.vue?vue&type=script&lang=js"
export * from "./AttributeInfo.vue?vue&type=script&lang=js"

import "./AttributeInfo.vue?vue&type=style&index=0&id=f023bd68&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f023bd68"]])

export default __exports__